const BASE = `/payments/api/v2/products?product=`;
const PLACEHOLDER_HOST = 'https://placeholder';
const getPathWithParams = (path, requestQueryStringParams) => {
    // Поскольку объект `URL` требует наличие хоста в строке,
    // при получении относительного пути подставляем временный плейсхолдер,
    // убираемый в конце обработок.
    const isOriginalPathRelative = /^\w+:\/\/.+\//.test(path) === false;
    const paymentUrl = new URL(path, isOriginalPathRelative ? PLACEHOLDER_HOST : undefined);
    Object.entries(requestQueryStringParams).forEach(([key, val]) => {
        paymentUrl.searchParams.set(key, val);
    });
    return isOriginalPathRelative
        ? paymentUrl.href.replace(PLACEHOLDER_HOST, '')
        : paymentUrl.href;
};
const getPaymentLink = async (productName, options) => {
    var _a, _b;
    const customHost = (_a = options === null || options === void 0 ? void 0 : options.customHost) !== null && _a !== void 0 ? _a : "";
    try {
        const response = await fetch(`${customHost}${BASE}${productName}`, {
            credentials: "include",
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (response.ok) {
            const { data } = (await response.json());
            if (data.payment_path === null) {
                return {
                    paymentPath: data["payment_path"],
                    modifiedPaymentPath: null,
                    price: data["price"],
                    basePrice: data["base_price"],
                };
            }
            const modifiedPaymentPath = getPathWithParams(data["payment_path"], (_b = options === null || options === void 0 ? void 0 : options.requestQueryStringParams) !== null && _b !== void 0 ? _b : {});
            return {
                paymentPath: data["payment_path"],
                modifiedPaymentPath,
                price: data["price"],
                basePrice: data["base_price"],
            };
        }
        else {
            return Promise.reject(new Error(`
        Product name: ${productName},
        Status: ${response.status}
      `));
        }
    }
    catch (error) {
        return Promise.reject(error);
    }
};

export { getPaymentLink };
